<button
	uiNewButtonBasic
	(click)="clear()"
	style="padding-left: 8px; padding-right: 8px"
	class="fs-m fc-primary-500"
>
	{{ 'general.clear' | transloco }}
</button>
